module.exports = __webpack_public_path__ + "img/onenote.317d01d0.svg";